export const isNotEmpty = ({ value }) => {
	return value.trim().length > 0;
};

export const isChecked = ({ checked }) => {
	return checked === true;
};

export const hasMinimumPasswordLength = ({ value }) => {
	return new RegExp(/.{12,}/).exec(value) ? true : false;
};

export const hasLowerCaseCharacter = ({ value }) => {
	return new RegExp(/[a-zßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]{1,}/).exec(value) ? true : false;
};

export const hasUpperCaseCharacter = ({ value }) => {
	return new RegExp(/[A-ZÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞ]{1,}/).exec(value) ? true : false;
};

export const isValidEmailFormat = ({ value }) => {
	return new RegExp(/^[^\s@]+@[^\s@.,]+\.+[^\s@,]{2,}$/).exec(value) ? true : false;
};

export const isEmailDomainAllowed = ({ value, blacklist }) => {
	const parts = value.split('@');
	if (parts.length < 2 || !parts[1]) {
		return false;
	}
	const domain = parts[1].toLowerCase();
	return !blacklist.includes(domain);
};

export const isInternalEmailAddress = (emailAddress, regexPatterns) => {
	return regexPatterns.some((regEx) => emailAddress.match(regEx));
};
